import { combineReducers } from 'redux';
import userProfile from './userProfile/reducer';
import dashboardStats from './dashboardStats/reducer';
import reporting from './reporting/reducer';
import signup from './signup/reducer';
import login from './login/reducer';
import logout from './logout/reducer';
import superAdmin from './superAdmin/reducer';
import selfSignUp from './selfSignUp/reducer';
import support from './support/reducer';
import notification from './notification/reducer';
import rewards from './rewards/reducer';
import billing from './billing/reducer';
import roiCalculator from './roiCalculator/reducer';

export default combineReducers({
  userProfile,
  dashboardStats,
  reporting,
  signup,
  login,
  logout,
  superAdmin,
  selfSignUp,
  support,
  notification,
  rewards,
  billing,
  roiCalculator,
});
